type Data = Record<string, unknown>;
type Event = { type: string; timestamp: number; message?: string } & Data;

const activityLog: Record<string, Event[]> = {};
const MAX_LENGTH = 50;

export const logActivity = (
  uaId: string,
  type: string,
  data: Data,
  message?: string,
) => {
  if (!activityLog[uaId]) {
    activityLog[uaId] = [];
  }
  const event: Event = { type, ...data, timestamp: Date.now() };
  if (message) {
    event.message = message;
  }
  activityLog[uaId].push(event);
  if (activityLog[uaId].length > MAX_LENGTH) {
    activityLog[uaId].shift();
  }
};

export const getActivityLog = () => {
  const log: typeof activityLog = {};
  Object.keys(activityLog).forEach((key) => {
    log[key] = activityLog[key].sort((a, b) => b.timestamp - a.timestamp);
  });
  return log;
};
